import type { PageSection } from "@/templates/types"

/** Map stored JSON block array (e.g. campaigns.content_sections) to PageSection[]. */
export function blockJsonToPageSections(content: unknown, orgId: string): PageSection[] {
  const arr = Array.isArray(content) ? content : []
  return (arr as Record<string, unknown>[]).map((item, i) => ({
    id: String(item.id ?? crypto.randomUUID()),
    section_type: String(item.section_type ?? "paragraph"),
    order_index: typeof item.order_index === "number" ? item.order_index : i,
    content: (item.content as Record<string, unknown>) ?? null,
    page_id: "",
    org_id: orgId,
    is_visible: true,
  }))
}
